import React, { useEffect, useRef, useState } from 'react';
import { Checkbox } from '@material-ui/core';
import { ReactSVG } from 'react-svg';
import { Icons } from '@/assets';
import styles from './containerList.module.css';
import ActionMenu from '@/components/ContainerList/ActionMenu';
import FilterPanel from '@/ctComponents/Filter';
import { useOutsideAlerter } from '@/hocs';
import Modal from '@/ctComponents/Modal';
import AddNewContainersModal from './AddNewContainersModal';
import EditContainerModal from './EditContainerModal';
import AppointmentDisplay from './AppointmentDisplay';
import {
  AutoBookIndex,
  editAutoBookContainer,
  editAutoBookContainerInfo,
  getAutoBookContainerData,
  removeAutoBookContainer,
  saveAutobookPreferences,
  editAutobookTemplate,
  SaveApiResMessage,
} from '@/actions';
import SearchContainer from '../Appointments/SearchContainer';
import { noScroll } from '@/actions/Helper';
import { formatDateToUTC } from '@/ctUtlis/formatDate';
import { useNotify } from 'react-admin';
import SubmitButton from '@/ctComponents/submitButton';
import useMediaQuery from 'use-mediaquery';
import LoadingV2 from '@/components/Loading';
import AddButton from '@/components/AddButton';

const formatDate = (dateString) => {
  if (!dateString) return '';
  const date = new Date(dateString);
  const days = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
  const dayOfWeek = days[date.getUTCDay()];
  const day = String(date.getUTCDate()).padStart(2, '0');
  const month = String(date.getUTCMonth() + 1).padStart(2, '0');

  return `${dayOfWeek} ${month}/${day}`;
};

const ContainerSelector = ({
  clickConatiner,
  setClickConatiner,
  setTableData,
  setAutobookAppointmentsApiData,
  setSettings,
  setSaving_identifier,
  setStatus,
  setLoading,
  width,
  setHistoryList,
  selectedContainers,
  setSelectedContainers,
  setSavedTemplates,
  reLoadAutobook,
  setReLoadAutobook,
  setShowSavePreferences,
  showSavePreferences,
  selectedContainer,
  setSelectedContainer,
  setAutobookMode,
  reLoadAutobookContainer,
  setReLoadAutobookContainer,
  setActiveSection,
  clickedTemplate,
  preferenceName,
  setPreferenceName,
  setClickedTemplate,
  activeTab,
  setActiveTab,
  actionMenuAnchor,
  setActionMenuAnchor,
  collapsedRow,
  setCollapsedRow,
}) => {
  const notify = useNotify();
  const [tabs, setTabs] = useState([]);
  const [show, setShow] = useState(false);
  const [containers, setContainers] = useState([]);
  const [containerLoading, setContainerLoading] = useState(false);
  const [filterMenuOpen, setFilterMenuOpen] = useState(false);
  const [containerOptions, setContainerOptions] = useState([]);
  const [containerName, setContainerName] = useState([]);
  const [loadingSubmit, setLoadingSubmit] = useState(false);
  const autobookCollectorRef = useRef(null);
  const [autobookCollector, setAutobookCollector] = useState(true);
  const [displayNone, setDisplayNone] = useState(false);
  const [badgeHidden, setBadgeHidden] = useState(false);
  const [tabCounts, setTabCounts] = useState({
    available: 0,
    appointed: 0,
    inGated: 0,
    streetTurned: 0,
  });
  const [showEditModal, setShowEditModal] = useState(false);
  const [containerForEdit, setContainerForEdit] = useState(null);
  const [containerForDelete, setContainerForDelete] = useState(null);
  const handleEdit = (container) => {
    setContainerForEdit(container);
    setShowEditModal(true);
    setActionMenuAnchor(null);
  };
  const [filters, setFilters] = useState({
    size: [],
    ssl: [],
  });

  const smallScreen = useMediaQuery('(max-width: 1440px)');
  useEffect(() => {
    noScroll();
  }, [tabCounts]);

  useEffect(() => {
    setTabs([
      {
        id: 'available',
        label: 'Available',
        shortLabel: 'Avail',
        count: tabCounts?.available,
        className: styles.available,
      },
      {
        id: 'appointed',
        label: 'Appointed',
        shortLabel: 'Appt',
        count: tabCounts?.appointed,
        className: styles.appointed,
      },
      {
        id: 'inGated',
        label: 'In-Gated',
        shortLabel: 'InGate',
        count: tabCounts?.inGated,
        className: styles.inGated,
      },
      {
        id: 'streetTurned',
        label: 'Street Turned',
        shortLabel: 'ST',
        count: tabCounts?.streetTurned,
        className: styles.streetTurned,
      },
    ]);
  }, [tabCounts]);

  const handleTabChange = (tabId) => {
    setActiveTab(tabId);
  };

  const resetFilters = () => {
    setContainerLoading(true);
    setFilters({
      size: [],
      ssl: [],
    });
    getAutobook({ specifications: [], shippingLines: [], container_name: '' });
  };

  const wrapperRef = useRef(null);

  useOutsideAlerter(wrapperRef, () => setFilterMenuOpen(false));

  const handleContainerSelect = (containerId) => {
    setSelectedContainer(containerId);
    if (selectedContainers.includes(containerId)) {
      setSelectedContainers(
        selectedContainers.filter((id) => id !== containerId)
      );
    } else {
      setSelectedContainers([...selectedContainers, containerId]);
    }
  };

  const [edittedRow, setEdittedRow] = useState({
    id: 1,
    book_id: '',
    container: '',
    container_id: null,
    size: '',
    ssl: '',
    ssl_id: '',
    specification_id: '',
    license: '',
  });

  const handleSaveEdit = () => {
    const AutobookId = containerForEdit?.id;
    const data = {};
    editAutoBookContainer({ AutobookId, data })
      .then((res) => {
        SaveApiResMessage({
          title: res?.data?.messageHeader,
          message: res?.message,
          mode: 'success',
        });
        setShowEditModal(false);
      })
      .catch((err) => {
        SaveApiResMessage({
          title: 'Error',
          message: err,
          mode: 'error',
        });
      });
  };

  const [showDeleteModal, setShowDeleteModal] = useState(false);

  const handleDelete = (container) => {
    setShowDeleteModal(true);
    setActionMenuAnchor(null);
    setContainerForDelete(container);
  };
  const handleConfirmDelete = () => {
    removeAutoBookContainer(containerForDelete?.id).then((res) => {
      setContainers(
        containers
          .map((group) => ({
            ...group,
            containers: group.containers.filter(
              (c) => c.id !== containerForDelete?.id
            ),
          }))
          .filter((group) => group.containers.length > 0)
      );
      SaveApiResMessage({
        title: res?.data?.messageHeader,
        message: 'Autobook deleted successfully',
        mode: 'success',
      });
      setContainerForDelete(null);
    });
    setShowDeleteModal(false);
    setContainerForDelete(null);
  };

  const actionMenuItems = [
    {
      id: 'edit',
      label: 'Edit',
      icon: Icons.editIcon,
      onClick: handleEdit,
    },
    {
      id: 'delete',
      label: 'Delete',
      icon: Icons.deleteIcon,
      onClick: handleDelete,
    },
  ];

  useEffect(() => {
    !show && getAutobook(null, false);
  }, [containerName, show]);

  useEffect(() => {
    !show && getAutobook();
  }, [activeTab]);

  useEffect(() => {
    if (reLoadAutobook) {
      getAutobook(null, false);
      setReLoadAutobook(false);
    }
  }, [reLoadAutobook]);

  useEffect(() => {
    handleContainerClick(
      containers.find((container) => container.id === clickConatiner),
      true
    );
    setReLoadAutobookContainer(false);
  }, [reLoadAutobookContainer]);

  useEffect(() => {
    if (!clickConatiner) {
      setTimeout(() => {
        setCollapsedRow(clickConatiner);
      }, 500);
    } else {
      setCollapsedRow(clickConatiner);
    }
  }, [clickConatiner]);

  useEffect(() => {
    if (tabs.length > 0 && !activeTab) {
      setActiveTab(tabs[0].id);
    }
  }, [tabs, activeTab]);

  const getAutobook = (data = null, loadOn = true) => {
    if (loadOn) {
      setContainerLoading(true);
    }
    AutoBookIndex(
      activeTab,
      data
        ? data
        : {
            specifications: filters?.size,
            shippingLines: filters?.ssl,
            container_name: containerName,
          }
    ).then((res) => {
      const transformedArray = [
        {
          category: 'size',
          title: 'Size',
          options:
            res.data?.specifications?.map((s) => ({
              label: s?.size_type,
              value: s?.id,
            })) || [],
        },
        {
          category: 'ssl',
          title: 'SSL',
          options:
            res.data?.shippingLines.map((t) => ({
              label: t?.name,
              value: t.id,
            })) || [],
        },
      ];
      setContainerOptions(transformedArray);
      setTabCounts(res.data.counts);
      setSavedTemplates(res.data.autobook_templates);
      const autobooksByDate = res.data.autobooks || {};
      const groupedContainers = Object.entries(autobooksByDate)
        .map(([date, containers]) => {
          if (containers.length > 0) {
            return {
              date: date,
              containers: transformAppointmentsData(containers),
            };
          }
          return null;
        })
        .filter(Boolean);
      setContainers(groupedContainers);
      setContainerLoading(false);
    });
  };
  const transformAppointmentsData = (data) => {
    return data.map((item, index) => ({
      id: item?.id || null,
      idx: index + 1,
      container_id: item?.container_id || null,
      number: item?.container_string || '',
      size: item?.specification?.size_type || '',
      type: `${item?.specification?.size_type},${item?.ssl?.name}` || '',
      ssl: item?.ssl?.name || '',
      license: item?.license_plate || '',
      is_liveOnLoad: item?.is_liveOnLoad || false,
      status: item?.status || '',
      created_at: item?.created_at,
      appointments: item?.appointments,
      gated_in: item?.container?.gated_in,
    }));
  };
  const handleContainerClick = (container, reload) => {
    if (clickConatiner && clickConatiner === container?.id) {
      setClickConatiner(null);
      handleCollectorClick();
    }

    if (clickConatiner !== container?.id || reload) {
      setActiveSection('hour');
      setClickConatiner(container?.id);
      setSelectedContainer(container?.id);
      setAutobookMode({
        status: container?.status === 'ENABLED' ? true : false,
        autobookId: container?.id,
      });
      setLoading(true);
      getAutoBookContainerData(container?.id).then((res) => {
        const data = {
          id: res.autobook?.id || null,
          idx: container?.idx,
          is_liveOnLoad:
            res?.autobook?.is_liveOnLoad === true
              ? 'Live Unload '
              : 'Drop & Pick' || '',
          number: res.autobook?.container_string || '',
          size: res.autobook?.specification?.size_type || '',
          type:
            `${res.autobook?.specification?.size_type},${res.autobook?.ssl?.name}` ||
            '',
          ssl: res.autobook?.ssl?.name || '',
          license: res.autobook?.license_plate || '',
          status: res.autobook?.status || '',
          lfd: res.autobook?.container?.last_free_day
            ? formatDateToUTC(res.autobook?.container?.last_free_day)
            : '',
          created_date: res.autobook?.created_at
            ? formatDateToUTC(res.autobook?.created_at)
            : '',
        };
        const AutobookAppointmentsApiData = {
          containerId: res.autobook?.container?.id || null,
          size: res.autobook?.specification?.id || '',
          ssl: res.autobook?.ssl?.id || '',
        };

        setTableData(data);
        setAutobookAppointmentsApiData(AutobookAppointmentsApiData);
        setSettings(res.autobook?.settings);
        setSaving_identifier(res.autobook?.saving_identifier);
        setStatus(res.autobook?.status);
        setHistoryList(res.autobook?.event_history.reverse());
        setLoading(false);
      });
    }
  };
  const handleEditSubmit = () => {
    setLoadingSubmit(true);
    const AutobookId = edittedRow.book_id;
    const data = {
      container_string: edittedRow?.container,
      ssl_id: edittedRow.ssl_id,
      specification_id: edittedRow.specification_id,
      license_plate: edittedRow?.license,
    };
    editAutoBookContainerInfo({ AutobookId, data })
      .then((res) => {
        getAutobook();
        setLoading(false);
        setLoadingSubmit(false);
        setShowEditModal(false);
        SaveApiResMessage({
          title: res?.data?.messageHeader,
          message: res,
          mode: 'success',
        });
      })
      .catch((err) => {
        SaveApiResMessage({
          title: 'Error',
          message: err,
          mode: 'error',
        });
        setLoadingSubmit(false);
      });
  };

  const handleSavePreferencesSubmit = () => {
    setLoadingSubmit(true);
    const AutobookId = selectedContainer;
    const templateId = clickedTemplate?.value;
    clickedTemplate
      ? editAutobookTemplate({
          AutobookTemplateId: templateId,
          data: {
            title: preferenceName,
          },
        })
          .then((res) => {
            setLoadingSubmit(false);
            setShowSavePreferences(false);
            setClickedTemplate(null);
            setSavedTemplates(res?.data?.templates);
            SaveApiResMessage({
              title: res?.data?.messageHeader,
              message: res.message,
              mode: 'success',
            });
            setLoading(false);
          })
          .catch((err) => {
            SaveApiResMessage({
              title: 'Error',
              message: err.message,
              mode: 'error',
            });
            setLoadingSubmit(false);
          })
      : saveAutobookPreferences(AutobookId, preferenceName)
          .then((res) => {
            getAutobook();
            setLoadingSubmit(false);
            setShowSavePreferences(false);
            SaveApiResMessage({
              title: res?.data?.messageHeader,
              message: res,
              mode: 'success',
            });
            setLoading(false);
          })
          .catch((err) => {
            SaveApiResMessage({
              title: 'Error',
              message: err,
              mode: 'error',
            });
            setLoadingSubmit(false);
          });
  };

  useEffect(() => {
    if (!clickConatiner) {
      autobookCollectorRef.current.style.minWidth = smallScreen
        ? '490px'
        : '520px';
    }
    if (clickConatiner) {
      autobookCollectorRef.current.style.width = '21%';
      autobookCollectorRef.current.style.minWidth = '290px';
      setDisplayNone(true);
      setAutobookCollector(false);
      setTimeout(() => {
        setBadgeHidden(true);
      }, 100);
    }
  }, [clickConatiner]);

  const handleCollectorClick = () => {
    if (collapsedRow) {
      setTimeout(() => {
        setCollapsedRow(!collapsedRow);
      }, 500);
    }

    if (autobookCollector) {
      autobookCollectorRef.current.style.width = '21%';
      autobookCollectorRef.current.style.minWidth = '290px';
      setDisplayNone(true);
      setBadgeHidden(true);
      setAutobookCollector(false);
      setCollapsedRow(true);
    } else {
      autobookCollectorRef.current.style.minWidth = smallScreen
        ? '490px'
        : '520px';
      setTimeout(() => {
        setAutobookCollector(true);
        setDisplayNone(false);
        setBadgeHidden(false);
        setClickConatiner(null);
      }, 500);
    }
  };

  return (
    <div
      ref={autobookCollectorRef}
      className={styles.containerList}
      style={{
        width: width ? `${width}px` : '520px',
        minWidth: width ? `${width}px` : '520px',
      }}>
      <div className={styles.headerLeft}>
        <h2 className={styles.title}>
          <ReactSVG style={{ height: '25px' }} src={Icons.autobookContainer} />
          Containers
        </h2>
        <AddButton
          onClick={() => {
            setShow(true);
          }}
        />
      </div>
      <div className={styles.containerListBody}>
        <div style={{ display: 'flex' }}>
          <div className={styles.tabContainer}>
            {tabs.map((tab) => (
              <button
                key={tab.id}
                className={`${styles.tabInItem} ${tab.className} ${
                  activeTab === tab.id ? styles.selected : ''
                }`}
                onClick={() => {
                  handleTabChange(tab.id);
                }}>
                <div className={styles.tabContent}>
                  {displayNone ? tab.shortLabel : tab.label}
                  {tab.count > 0 && (
                    <span
                      className={`${
                        activeTab === tab.id ? styles.activeBadge : styles.badge
                      } ${!displayNone ? styles.badgeVisible : ''} ${
                        badgeHidden ? styles.badgeHidden : ''
                      }`}>
                      {tab.count}
                    </span>
                  )}
                </div>
              </button>
            ))}
          </div>
          <div
            onClick={() => {
              handleCollectorClick();
            }}
            className={
              autobookCollector
                ? styles.autobookCollectorWrapper
                : styles.autobookCollectorWrapperCollapsed
            }>
            <ReactSVG src={Icons.autobookCollector} />
          </div>
        </div>
        <div className={styles.searchContainer}>
          <SearchContainer setContainerName={setContainerName} width={'100%'} />
          <div className={styles.filterButtonWrapper} ref={wrapperRef}>
            <button
              className={`${styles.filterButton} ${
                filterMenuOpen ? styles.active : ''
              }`}
              onClick={() => {
                setFilterMenuOpen((prev) => !prev);
              }}>
              <ReactSVG src={Icons.filterNew} />
            </button>
            {filterMenuOpen && (
              <div className={styles.FilterPanel}>
                <FilterPanel
                  options={containerOptions}
                  filters={filters}
                  setFilters={setFilters}
                  resetFilters={resetFilters}
                  apply={getAutobook}
                  setDisplay={setFilterMenuOpen}
                />
              </div>
            )}
          </div>
        </div>
        <div className={styles.containerItems}>
          {containerLoading ? (
            <div style={{ height: '30vh' }}>
              <LoadingV2 />
            </div>
          ) : containers.length > 0 ? (
            containers.map((group) => (
              <React.Fragment key={group.date}>
                <div className={styles.dateHeader}>
                  <span className={styles.dateHeaderText}>
                    {formatDate(group.date)}
                  </span>
                </div>
                {group.containers.map((container) => (
                  <div
                    key={container.id}
                    className={
                      selectedContainers.includes(container.id) ||
                      clickConatiner === container.id
                        ? styles.containerItemSelected
                        : styles.containerItem
                    }
                    style={{
                      backgroundColor:
                        container?.id === clickConatiner && '#F5F5F5',
                      border:
                        (activeTab === 'appointed' ||
                          activeTab === 'inGated') &&
                        container?.appointments !== null &&
                        container?.appointments?.length > 0 &&
                        container?.appointments[0]?.from_autobook === 1 &&
                        '1px solid #1fc16b',
                    }}
                    onClick={() => handleContainerClick(container)}>
                    <div className={styles.containerItemWrapper}>
                      <div className={styles.containerItemLeft}>
                        <Checkbox
                          style={{
                            padding: '4px',
                          }}
                          checked={selectedContainers.includes(container.id)}
                          onChange={() => handleContainerSelect(container.id)}
                          color="primary"
                        />
                        <div className="h-full flex flex-col justify-center">
                          <div className={styles.containerInfo}>
                            <div className={styles.containerNumber}>
                              {container.number}
                            </div>{' '}
                            <span className={styles.seperator}>|</span>
                            <div className={styles.containerType}>
                              {container.type}
                            </div>
                          </div>
                          <div
                            className={
                              container.autoBook
                                ? styles.autoBookStatusActive
                                : styles.autoBookStatus
                            }>
                            <span
                              style={{
                                color:
                                  container.status !== 'DISABLED'
                                    ? '#1FC16B'
                                    : '#99A0AE',
                              }}>
                              AutoBook is{' '}
                              {container.status !== 'DISABLED' ? 'On' : 'Off'}
                            </span>
                            <div className={styles.containerItemRight}>
                              {!collapsedRow && (
                                <span className={styles.containerRowActions}>
                                  <ReactSVG
                                    onClick={(event) => {
                                      event.stopPropagation();
                                      handleEdit(container);
                                    }}
                                    src={Icons.penNew}
                                    className={styles.icon}
                                    beforeInjection={(svg) => {
                                      svg
                                        .querySelectorAll('path')
                                        .forEach((path) => {
                                          path.setAttribute(
                                            'stroke',
                                            '#131617'
                                          );
                                        });
                                    }}
                                  />
                                  <ReactSVG
                                    onClick={(event) => {
                                      event.stopPropagation();
                                      handleDelete(container);
                                    }}
                                    src={Icons.trashIcon}
                                    className={styles.icon}
                                    beforeInjection={(svg) => {
                                      svg
                                        .querySelectorAll('path')
                                        .forEach((path) => {
                                          path.setAttribute(
                                            'stroke',
                                            '#fb3f4f'
                                          );
                                        });
                                    }}
                                  />
                                </span>
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <AppointmentDisplay
                      container={container}
                      activeTab={activeTab}
                      collapsedRow={collapsedRow}
                    />
                  </div>
                ))}
              </React.Fragment>
            ))
          ) : (
            <div className={styles.emptyState}>
              <h3>No containers found</h3>
              <p>There are no containers available for this tab.</p>
            </div>
          )}
        </div>
        <Modal
          show={show}
          notClose={true}
          children={
            <AddNewContainersModal
              transformAppointmentsData={transformAppointmentsData}
              setShow={setShow}
              ContainerOptions={containerOptions}
              setContainers={setContainers}
            />
          }
          icon={'addItem'}
          title={'Add New Containers'}
          setShow={setShow}
          minWidth="unset"
        />
        <ActionMenu
          anchorEl={actionMenuAnchor}
          onClose={() => setActionMenuAnchor(null)}
          menuItems={actionMenuItems}
        />

        <Modal
          show={showDeleteModal}
          setShow={setShowDeleteModal}
          icon={'trashIcon'}
          title={'Delete Container'}
          submitText={'Yes, delete'}
          submit={handleConfirmDelete}
          children={
            <span className={styles.deleteModalContent}>
              Are you sure you want to delete this container?
            </span>
          }
        />

        <EditContainerModal
          show={showEditModal}
          setShow={setShowEditModal}
          onSave={handleSaveEdit}
          containerData={containerForEdit}
          options={containerOptions}
          loadingSubmit={loadingSubmit}
          handleSubmit={handleEditSubmit}
          edittedRow={edittedRow}
          setEdittedRow={setEdittedRow}
        />

        <Modal
          notClose={true}
          show={showSavePreferences}
          setShow={setShowSavePreferences}
          clickedTemplate={clickedTemplate}
          icon="saveData"
          title={preferenceName ? 'Edit Preferences' : 'Save Preferences'}>
          <div
            style={{ padding: '18px 0px 0px', width: '100%' }}
            className={styles.savePreferencesModalChild}>
            <div style={{ marginBottom: 16 }}>
              {preferenceName
                ? 'Update the name of your saved Autobook preference.'
                : 'Save Autobook preferences to reuse for other containers.'}
            </div>
            <div style={{ marginBottom: 24 }}>
              <label
                style={{ fontWeight: 600, display: 'block', marginBottom: 8 }}>
                Preference Name
              </label>
              <input
                type="text"
                value={preferenceName}
                onChange={(e) => setPreferenceName(e.target.value)}
                placeholder="Enter your Preference Name"
                style={{
                  width: '55%',
                  padding: '10px 12px',
                  border: '1px solid #E3E6E8',
                  borderRadius: 6,
                  fontSize: 16,
                  outline: 'none',
                }}
              />
            </div>
            <div className={styles.buttonContainer}>
              <SubmitButton
                text={'Save'}
                onClick={() => {
                  handleSavePreferencesSubmit();
                }}
                loading={loadingSubmit}
                disable={!preferenceName}
              />
            </div>
          </div>
        </Modal>
      </div>
    </div>
  );
};

export default ContainerSelector;
